///<reference path="../common/custom-validation.model.ts"/>
///<reference path="../common/custom-validation-base.ts"/>
///<reference path="../collections/report-payroll-employees.collection.ts"/>

module Meevo.Components.Controls.SmartMover {

    export class RequiredValidation extends CustomValidationBase implements ICustomValidation {

        readonly message?: string;

        get placement(): ErrorMessagePlacements {
            return 'top';
        }

        get valid(): boolean {
            return this.collection.selectedModelsLength > 0;
        }

        constructor(private collection: SmartMoverCollectionBase<any>, message?: string) {
            super();

            this.message = message;
        }
    }
}
